import React from "react";
import {
  FormDataConsumer,
  DateInput,
  required
} from "react-admin";

const PolicyExpiryDateInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isBusinessTypeOne =
        Number(formData?.bzTypeId) === 1;

      return (
        <DateInput
          {...props}
          source="policyExpiryDate"
          label="Policy Expiry Date"
          fullWidth
          validate={
            isBusinessTypeOne
              ? []
              : [required()]
          }
          disabled={isBusinessTypeOne}
        />
      );
    }}
  </FormDataConsumer>
);

export default PolicyExpiryDateInput;